import {z} from 'zod';
import {Address} from './address';

/**
 * Contains all personal data of a customer
 * (Name, contact and address)
 */
export const CustomerType = z.enum(['PRIVATE', 'SOLE_TRADER', 'COMMERCIAL']);
export type CustomerType = z.infer<typeof CustomerType>;

export const PersonalData = z.object({
  oid: z.number().nullable(),
  companyName: z.string().nullable().optional(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  address: Address.nullable(),
  businessAddress: Address.nullable().optional(),
  maritalStatus: z.string().nullable(),
  customerType: CustomerType.nullable(),
  salutation: z.string().optional().nullable(),
});

export type PersonalData = z.infer<typeof PersonalData>;
